<div class="dialog-container flex-direction-column justify-content-center">

  <div class="d-flex px-sm-4 mt-3 profilePic flex-direction-column align-items-center mb-20px">
    <label for="forImage" (click)="imageInput.click()">
      <div id="forImage"
           class="col-sm-12 text-center image-div-text image flex-direction-column align-items-center justify-content-center">
        @if (currentProfileImageUrl) {
          <img [src]="currentProfileImageUrl "
               class="image-style"
               alt="">
        } @else if (tempProfileImage) {
          <img [src]="tempProfileImage ? getImageAsSource(tempProfileImage) : 'assets/svg/defaultUserIcon.svg'"
               alt="" class="image-style">
        } @else {
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.41537 26.082C8.05425 24.9801 9.73481 24.1352 11.457 23.5475C13.1793 22.9594 15.0265 22.6654 16.9987 22.6654C18.9709 22.6654 20.8227 22.9594 22.5541 23.5475C24.2858 24.1352 25.9711 24.9801 27.61 26.082C28.7488 24.7023 29.5798 23.2624 30.1029 21.7624C30.6259 20.2624 30.8875 18.6745 30.8875 16.9987C30.8875 13.082 29.5519 9.78801 26.8808 7.11662C24.2094 4.44551 20.9154 3.10995 16.9987 3.10995C13.082 3.10995 9.788 4.44551 7.11662 7.11662C4.4455 9.78801 3.10995 13.082 3.10995 16.9987C3.10995 18.6745 3.37606 20.2624 3.90828 21.7624C4.44078 23.2624 5.27648 24.7023 6.41537 26.082ZM16.9937 18.3874C15.3768 18.3874 14.0149 17.8326 12.9083 16.7229C11.8019 15.6129 11.2487 14.2494 11.2487 12.6325C11.2487 11.0155 11.8037 9.65384 12.9137 8.54745C14.0234 7.44078 15.3868 6.88745 17.0037 6.88745C18.6206 6.88745 19.9825 7.44245 21.0891 8.55245C22.1955 9.66245 22.7487 11.0259 22.7487 12.6429C22.7487 14.2598 22.1937 15.6215 21.0837 16.7279C19.974 17.8343 18.6106 18.3874 16.9937 18.3874ZM16.9874 33.6654C14.6791 33.6654 12.5099 33.2279 10.4799 32.3529C8.44967 31.4779 6.6837 30.2858 5.18203 28.7766C3.68009 27.2672 2.49634 25.5001 1.63078 23.4754C0.764948 21.4506 0.332031 19.2872 0.332031 16.985C0.332031 14.6827 0.769531 12.5191 1.64453 10.4941C2.51953 8.46939 3.71161 6.70703 5.22078 5.20703C6.73023 3.70703 8.49731 2.51953 10.522 1.64453C12.5468 0.769531 14.7102 0.332031 17.0124 0.332031C19.3147 0.332031 21.4783 0.769531 23.5033 1.64453C25.528 2.51953 27.2904 3.70703 28.7904 5.20703C30.2904 6.70703 31.4779 8.47092 32.3529 10.4987C33.2279 12.5265 33.6654 14.6906 33.6654 16.9912C33.6654 19.292 33.2279 21.4541 32.3529 23.4774C31.4779 25.5008 30.2904 27.2672 28.7904 28.7766C27.2904 30.2858 25.5252 31.4779 23.4949 32.3529C21.4649 33.2279 19.2958 33.6654 16.9874 33.6654Z"
              fill="#6B6C77"/>
          </svg>
          <span class="image-div-text mt-6px">Select the image</span>
        }
      </div>
    </label>
    <input type="file" #imageInput name="profilePic"
           hidden (change)="onProfileImageChange($event, imageInput)"
           accept="image/jpeg,image/png">
    @if (!isDefaultImage() || currentProfileImageUrl) {
      <button type="button" (click)="deleteProfileImage()" class="clear-icon">
        <i class="material-icons">clear</i>
      </button>
    }
  </div>
  <form [formGroup]="editForm" method="post">
    <div class="form-data">
      <app-filled-form-field [label]="'profile_form.name' | translate" [type]="'input'" [errorMessage]="getErrorMessage('name')"
                             [formControlName]="'name'" [value]="user.name"
                             [isControlInvalid]="editForm.get('name')?.invalid && editForm.get('name')?.touched">
      </app-filled-form-field>
      <app-filled-form-field [label]="'profile_form.surname' | translate" [type]="'input'" [errorMessage]="getErrorMessage('surname')"
                             [formControlName]="'surname'" [value]="user.surname"
                             [isControlInvalid]="editForm.get('surname')?.invalid && editForm.get('surname')?.touched">
      </app-filled-form-field>
      <app-filled-form-field [label]="'profile_form.email'" [type]="'input'" [errorMessage]="getErrorMessage('email')"
                             [formControlName]="'email'" [value]="user.email" [readonly]="isPhoneChanged"
                             [isControlInvalid]="editForm.get('email')?.invalid && editForm.get('email')?.touched">
      </app-filled-form-field>
      <div class="form-group email-form-group"
        [ngClass]="{'disabled': isEmailChanged}"
      >
        <div class="line">
          <input formControlName="phoneNumber" type="tel" id="phone"
                 [disabled]="isEmailChanged"
                 [readonly]="isEmailChanged"
                 class="form-control form-control-lg confirm-password-reduced-placeholder-width form-tel phone-input"
                 placeholder="77 123456" [value]="user.phoneNumber"
                 #phoneInput/>
        </div>
        <div class="validation phone-number-validation"
          [ngClass]="{'invalid-phone-number': isControlInvalid('phoneNumber')}"
        >
          <small>{{ isControlInvalid('phoneNumber') ? getErrorMessage('phoneNumber') : '' }}</small>
        </div>
      </div>
    </div>
    <div class="dialog-actions justify-content-center">
      <button class="edit-button text-button short-button width-120 d-flex justify-content-center"
              (click)="onCancel($event)">{{ 'delete_card_from_team.cancel' | translate }}
      </button>

      <button (click)="edit()" [disabled]="isSaveButtonDisabled()" class="filled-button short-button width-120 d-flex justify-content-center">{{ 'user_card.save' | translate }}</button>
    </div>
  </form>
</div>
